import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { ForcedPasswordChange } from "../auth/ForcedPasswordChange";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { MobileDrawer } from "./MobileDrawer";
import { Footer } from "./Footer";

/** Grundgerüst für alle geschützten Seiten: Sidebar links, Topbar oben, Inhalt scrollbar, Footer unten. */
export function Layout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { user } = useAuth();

  // Blockiert die gesamte Anwendung, bis das Passwort geändert wurde
  // (siehe ForcedPasswordChange.tsx) - greift noch vor Sidebar/Routing.
  if (user?.mustChangePassword) {
    return <ForcedPasswordChange />;
  }

  return (
    <div className="flex h-screen w-full overflow-hidden bg-surface">
      <Sidebar />
      <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar onMenuClick={() => setDrawerOpen(true)} />
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
